module.exports = __webpack_public_path__ + "img/barberton-kleuterskool.12ceee65.svg";